/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import router from '@/router/index'
import axios from '../../helpers/axios.js'

export default {
  loginAttempt ({ dispatch }, payload) {
    // Try to login
    dispatch('login', payload)
    
  },
  login ({ state, dispatch }, payload) {

    // If user is already logged in notify and exit
    if (state.isUserLoggedIn()) {
      // Close animation if passed as payload
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })

      return false
    }

    const data = JSON.stringify({
      username: payload.userDetails.username,
      password: payload.userDetails.password
    })
    // Try to sigin
    // firebase.auth().signInWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)
    axios.post('auth/login', data).then((result) => {

      if (payload.closeAnimation) payload.closeAnimation()
      payload.notify({
        time: 5000,
        title: 'Success',
        text: 'Success',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
      dispatch('update_Token_and_userInfo', {
        access_token : result.data.access_token
      })
    }, () => {

      // Close animation if passed as payload
      if (payload.closeAnimation) payload.closeAnimation()

      payload.notify({
        time: 5000,
        title: 'Error',
        text: 'Identifiant ou Mot de passe incorrect',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })

    }).catch(() => {
      
      if (payload.closeAnimation) payload.closeAnimation()

    })
  },

  // Google Login
  loginWithGoogle ({ state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      return false
    }
  
  },

  update_Token_and_userInfo ({commit}, payload) {
    commit('UPDATE_USER_TOKEN', payload.access_token, { root: true })
    localStorage.setItem('token', payload.access_token)
    axios.get('getUserProfile', {
      headers : {
        'Authorization':`Bearer ${ localStorage.getItem('token')}`
      }
    }).then((result) => {
      // dispatch('updateUsername', {
      //   user: result.data,
      //   username: `${result.data.firstName} ${result.data.lastName}`,
      //   notify: payload.notify,
      //   isReloadRequired: true
      // })
      commit('UPDATE_USER_INFO', result.data, { root: true })
      router.push(router.currentRoute.query.to || '/')
    }).catch(() => {
      if (payload.closeAnimation) payload.closeAnimation()
    })
     
  },

  registerUser () {
 
  },

  updateUsername ({ commit }, payload) {
    payload.user.updateProfile({
      displayName: `${payload.firstName} ${payload.lastName}`
    }).then(() => {

      // If username update is success
      // update in localstorage
      const newUserData = Object.assign({}, payload.user.providerData[0])
      newUserData.displayName = payload.displayName
      commit('UPDATE_USER_INFO', newUserData, { root: true })
      router.push(router.currentRoute.query.to || '/')
      // If reload is required to get fresh data after update
      // Reload current page
      if (payload.isReloadRequired) {
        router.push(router.currentRoute.query.to || '/')
      }
    }).catch((err) => {
      payload.notify({
        time: 8800,
        title: 'Error',
        text: err.message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    })
  }


}
